import { render, staticRenderFns } from "./societyCen.vue?vue&type=template&id=563332f6&scoped=true"
import script from "./societyCen.vue?vue&type=script&lang=js"
export * from "./societyCen.vue?vue&type=script&lang=js"
import style1 from "./societyCen.vue?vue&type=style&index=1&id=563332f6&prod&scoped=true&lang=scss"
import style2 from "./societyCen.vue?vue&type=style&index=2&id=563332f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563332f6",
  null
  
)

export default component.exports